import * as types from '../../actions/ActionTypes';

const INITIAL_STATE = {
    view: null,
    displayName: null,
    typeFilter: null,
    pointsFilter: null
};

const setBadgesPageView = (state, action) => {
    return {
        ...state,
        view: action.view,
        displayName: action.displayName !== undefined ? action.displayName : state.displayName
    };
};

const resetBadgesPageView = () => INITIAL_STATE;

const setBadgesFilter = (type, state, action) => ({
    ...state,
    [type + 'Filter']: action.value
});

const resetBadgesFilters = (state) => ({
    ...state,
    typeFilter: null,
    pointsFilter: null
});

const handlers = {
    [types.SET_BADGES_PAGE_VIEW]: setBadgesPageView,
    [types.RESET_BADGES_PAGE_VIEW]: resetBadgesPageView,
    [types.SET_BADGES_TYPE_FILTER]: setBadgesFilter.bind(this, 'type'),
    [types.SET_BADGES_POINTS_FILTER]: setBadgesFilter.bind(this, 'points'),
    [types.RESET_BADGES_FILTERS]: resetBadgesFilters
};

export const getBadgesPage = (state) => state.badgesPage;

export default function badgesPage(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
